<!-- Begin Give Lively Fundraising Widget -->
<div
  data-widget-src="https://secure.givelively.org/donate/disaster-accountability-project?ref=sd_widget"
  class="gl-branded-donation-widget"
  id="give-lively-widget"
></div>
<!-- End Give Lively Fundraising Widget -->
